import PaymentMethodSelect from './PaymentMethodSelect';

export default PaymentMethodSelect;
